import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { QuestionAnswer, TopicAnswers } from '@app/_models';
import { LocationService } from '@app/_services';
import { CourseService } from '@app/_services/course.service';
import { TopicShareService } from '@app/_services/topic.share.service';
import { first } from 'rxjs/operators';

@Component({
    selector: 'frontline-data-distribution',
    templateUrl: 'frontline-data-distribution.component.html'
})
export class FrontlineDataDistributionComponent {

    @Input() zipCode: any;
    @Input() device: any;

    frontlineDataDistribution: any;

    constructor(private locationService: LocationService) { }

    ngOnInit() {
        this.locationService.getFrontlineDistributionData().pipe(first()).subscribe(data => {
            this.frontlineDataDistribution = data;

            this.frontlineDataDistribution.forEach(row => {

                row.white = row.pct_white_alone * 100;
                row.black = row.pct_black_or_african_american_alone * 100;
                row.asian = row.pct_asian_alone * 100;
                row.indianOrAlaskan = row.pct_american_indian_and_alaska_native_alone * 100;
                row.hawaiianOrPacific = row.pct_native_hawaiian_and_other_pacific_islander_alone * 100;
                row.latino = row.pct_hispanic_or_latino * 100;
                row.mixed = row.pct_two_or_more_races * 100;
                row.other = row.pct_some_other_race_alone * 100;
                row.male = row.pct_male * 100;
                row.female = row.pct_female * 100;
                row.genZ = row.pct_gen_z * 100;
                row.millennials = row.pct_millennials * 100;
                row.genX = row.pct_gen_x * 100;
                row.babyBoomers = row.pct_baby_boomers * 100;

                let cumulative = 0;

                row.pieChartStyle = `conic-gradient(
                var(--dark-gray) ${row.white}%,
                var(--red) 0 ${cumulative = row.white + row.black}%,
                var(--blue) 0 ${cumulative = cumulative + row.asian}%,
                var(--purple) 0 ${cumulative = cumulative + row.indianOrAlaskan}%,
                var(--pink) 0 ${cumulative = cumulative + row.hawaiianOrPacific}%,
                var(--green) 0 ${cumulative = cumulative + row.latino}%,
                var(--yellow) 0 ${cumulative = cumulative + row.mixed}%,
                var(--orange)  0 ${cumulative = cumulative + row.other}%)`;

                console.log(cumulative);
            });

        });
    }
}